export default __webpack_public_path__ + "static/media/FiraSans-MediumItalic.8438e52c.woff";